/**
 * Teknik bazlı solver-doğrulamalı puzzle veri tipi.
 * Backend `scripts/generate_technique_puzzles.py` tarafından üretilir.
 */
export interface TechniquePuzzle {
  technique: string;
  /** 81 karakterlik puzzle stringi (0 boş, 1-9 dolu). */
  puzzle: string;
  /** 81 karakterlik tam çözüm stringi. */
  solution: string;
  givens: number;
  /** 1-5 zorluk. */
  difficulty: number;
  mode: 'strict' | 'flex';
  /** Solver'ın bu bulmacayı çözerken kullandığı tekniklerin sırası. */
  path: string[];
}

import data from './technique-puzzles.json';

const PUZZLES = data as Record<string, TechniquePuzzle>;

/** Verilen teknik slug'ı için solver-doğrulamalı puzzle (varsa). */
export function getTechniquePuzzle(slug: string): TechniquePuzzle | null {
  return PUZZLES[slug] ?? null;
}

/** Tüm slugları döndürür (sadece üretilmiş olanlar). */
export function getAvailableTechniqueSlugs(): string[] {
  return Object.keys(PUZZLES);
}
